import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ICartItem, ICartState } from './cart.reducer';

// feature selector
export const selectCartState = createFeatureSelector<ICartState>('cart');

// select all cart items
export const selectCartItems = createSelector(selectCartState, (state: ICartState) => state.cartItems);

// select cart item by color number
export const selectCartItemByColorName = (colorCode: string) =>
  createSelector(selectCartItems, (items: ICartItem[]) => items.find((item) => item.colorCode === colorCode));

// select total quantity of a specific item
export const selectItemQuantity = (colorCode: string) =>
  createSelector(selectCartItems, (items: ICartItem[]) => {
    const item = items.find((item) => item.colorCode === colorCode);
    return item ? item.quantity : 0;
  });

// select whether a specific product is in cart
export const selectIsProductInCart = (colorCode: string) =>
  createSelector(selectCartItems, (items: ICartItem[]) => items.some((item) => item.colorCode === colorCode));

export const selectEntryNumberByColorNumber = (colorCode: string) =>
  createSelector(selectCartItems, (items: ICartItem[]) => {
    const item = items.find((item) => item.colorCode === colorCode);
    if (item) {
      return item.entryNumber;
    }
    return null;
  });

export const selectSkuAndEntryNumberByColorNumber = (colorCode: string) =>
  createSelector(selectCartItems, (items: ICartItem[]) => {
    const item = items.find((item) => item.colorCode === colorCode);
    if (item) {
      return {
        sku: item.sku,
        entryNumber: item.entryNumber
      };
    }
    return null;
  });

export const selectSkuAndQuantityByColorNumber = (colorCode: string) =>
  createSelector(selectCartItems, (items: ICartItem[]) => {
    const item = items.find((item) => item.colorCode === colorCode);
    if (item) {
      return {
        product: item.sku,
        quantity: item.quantity
      };
    }
    return null;
  });

export const selectSkuAndQuantityAndEntryByColorNumber = (colorCode: string) =>
  createSelector(selectCartItems, (items: ICartItem[]) => {
    const item = items.find((item) => item.colorCode === colorCode);
    if (item) {
      return {
        product: item.sku,
        quantity: item.quantity,
        entryNumber: item.entryNumber
      };
    }
    return null;
  });
